require('./bootstrap');
require('./hotkeys.js');

import Template from './template.js';

window.Template = Template;

$('a.nav-section').click(function(){ location = this.href });

window.IslandCart = {...(window.IslandCart || {}),
    get theme(){
        return localStorage.getItem('theme') || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    },
    set theme(theme){
        localStorage.setItem('theme', theme);
        document.cookie = `theme=${theme};max-age=31536000;path=/`;
        document.body.dataset.bsTheme = theme;
        document.dispatchEvent(new Event('change.ic.theme'));
    },

    toast(message, type = 'success', config = {}){
        const container = document.getElementById('toasts');
        let toast = document.createElement('div');
        let colors = {
            'success': 'text-bg-success',
            'error': 'text-bg-danger',
            'info': 'text-bg-info',
            'warning': 'text-bg-warning',
        };
        toast.innerHTML = `
            <div class="toast align-items-center ${colors[type] ?? colors['info']} border-0 show" role="alert" aria-live="assertive" aria-atomic="true">
                <div class="d-flex">
                    <div class="toast-body">
                        ${message}
                    </div>
                    <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            </div>
        `;
        toast = toast.firstElementChild;

        container.append(toast);
        bootstrap.Toast.getOrCreateInstance(toast, config).show();
    }
};
IslandCart.theme = IslandCart.theme;

$('#theme-toggle').click(function(){
    let theme = IslandCart.theme;

    IslandCart.theme = theme != 'light' ? 'light' : 'dark';
});